<template>
  <div class="itp-list-con">
    <div class="app-sh-wrap">
      <input
        v-model="searchInput"
        v-cursor-end
        class="app-t-input app-search-input"
        type="text"
        enterkeyhint="done"
        :placeholder="`${t('enter_search_word')}`"
        @input="debounceSearch"
        @keyup.enter.prevent="handleSearchByEnter"
      />
      <IconSearch />
    </div>

    <ButtonFilterList
      :filter-list="CHAT_TYPE_DETAIL_FILTERS"
      :active-value="searchParams.chatType"
      @change="handleFilterClick"
    />

    <div v-if="chatDetailList.length > 0" class="list-area">
      <p class="total-num">
        {{ t('label_total') }}
        <span>{{ chatDetailList.length }}</span>
        {{ t('label_count_items_gun') }}
      </p>
      <ChatDetailItem :chat-list="chatDetailList" />

      <div v-if="pagination.hasMore" class="view-btn-wrap">
        <button class="all-view-btn" @click="showMore">
          <span>{{ t('more') }}</span>
          <IconArrow class="icon" />
        </button>
      </div>
    </div>

    <div v-else class="no-data pd-vertical-7 no-data-flex">
      <div class="icon-area">
        <img :src="getAssetImageUrl('app/status/no-data.svg')" alt="" />
      </div>
      <span>{{ t('no_records') }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { debounce } from 'lodash';

import ChatDetailItem from '@/components/domains/mobile/ChatDetailItem.vue';
import ButtonFilterList from '@/components/domains/mobile/common/ButtonFilterList.vue';
import IconArrow from '@/components/jh-app/icons/IconArrow.vue';
import IconSearch from '@/components/jh-app/icons/IconSearch.vue';
import { useChatDetailList } from '@/composables/domains/mobile/useChatDetailList';
import { CHAT_TYPE_DETAIL_FILTERS } from '@/utils/constants/common';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const { t } = useI18n();

const { chatDetailList, searchParams, pagination, setFilter, fetchChatDetailList } = useChatDetailList();

const searchInput = ref<string>('');

const handleSearch = () => {
  debounceSearch.cancel();

  setFilter({ keyword: searchInput.value.trim() });
};

const handleSearchByEnter = (e: KeyboardEvent) => {
  handleSearch();
  (e.target as HTMLInputElement).blur();
};

const debounceSearch = debounce(handleSearch, 500);

const handleFilterClick = (filter) => {
  setFilter({ chatType: filter });
};

const showMore = () => {
  fetchChatDetailList(pagination.value.nextOffset);
};

onMounted(async () => {
  setFilter({ chatType: 'ALL' });
  await fetchChatDetailList();
});
</script>

<style scoped lang="scss">
.itp-list-con {
  padding-top: 2.5rem;
  .app-tab-wrap {
    margin-bottom: $size-l;
    overflow-x: auto;
    max-width: 360px;
  }

  .list-area {
    margin-top: 1.5rem;
    .total-num {
      font-size: $font-size-psmall;
      margin-bottom: $size-s;
      span {
        font-weight: 700;
      }
    }
  }
}
.app-sh-wrap {
  position: relative;
  margin-bottom: $size-m;
  .app-search-input {
    background: $gray10;
    padding-left: 3rem;
    border: 1px solid transparent;
  }
  svg {
    position: absolute;
    top: 50%;
    left: 1rem;
    transform: translateY(-50%);
  }
}
.view-btn-wrap {
  display: flex;
  justify-content: center;
  padding: 0.5rem 0;
  .all-view-btn {
    padding: 0.75rem 0;
    height: 40px;
    text-decoration: none;
    span {
      font-size: $font-size-psmall;
      color: $color-gray-500;
      font-weight: 500;
    }
    svg {
      transform: rotate(180deg);
    }
  }
}
</style>
